import { ApplicationConfig, provideZoneChangeDetection, provideAppInitializer, inject } from "@angular/core";
import { provideRouter } from "@angular/router";
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";

import { routes } from "./app.routes";
import { provideHttpClient, withInterceptors } from "@angular/common/http";
import { provideTranslateService } from "@ngx-translate/core";
import { provideTranslateHttpLoader } from "@ngx-translate/http-loader";
import { IconService } from "./services/icon-service";
import { authInterceptor, AuthRedirectService } from "./features/auth";
import { provideNativeDateAdapter } from "@angular/material/core";

export const appConfig: ApplicationConfig = {
    providers: [
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideRouter(routes),
        provideHttpClient(withInterceptors([authInterceptor])),
        provideAppInitializer(() => {
            inject(IconService).registerIcons();
            inject(AuthRedirectService);
        }),
        provideTranslateService({
            loader: provideTranslateHttpLoader({
                resources: [
                    {
                        prefix: "./assets/i18n/user-module/",
                        suffix: ".json",
                    },
                ],
            }),
        }),
        provideAnimationsAsync(),
        provideNativeDateAdapter(),
    ],
};
